import React from 'react'
import './Login.css'

// Asset imports - using actual images from the repo
const imgMetamask = "/images/metamask.png"
const imgCoinbase = "data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='32' height='32' rx='8' fill='%230052FF'/%3E%3Ccircle cx='16' cy='16' r='7' fill='none' stroke='white' stroke-width='2'/%3E%3C/svg%3E"
const imgWalletConnect = "/images/WalletConnect.png"

export default function Login({ onConnect }) {
  const handleMetaMask = async () => {
    if (typeof window.ethereum !== 'undefined') {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' })
        if (accounts[0]) {
          onConnect(accounts[0])
        }
      } catch (error) {
        console.error('MetaMask connection error:', error)
      }
    } else {
      window.open('https://metamask.io/download/', '_blank')
    }
  }

  const handleCoinbase = () => {
    console.log('Coinbase Wallet connection coming soon')
  }

  const handleWalletConnect = () => {
    console.log('WalletConnect coming soon')
  }

  return (
    <div className="login-container" data-name="Login" data-node-id="4474:39629">
      <div className="login-content">
        <div className="login-left">
          <div className="wallet-form">
            <div className="form-header">
              <h1 className="form-title">Connect Wallet</h1>
              <p className="form-subtitle">Choose your favourite wallet to log in Integrity.</p>
            </div>
            
            <div className="wallet-options">
              <button onClick={handleMetaMask} className="wallet-button">
                <img src={imgMetamask} alt="MetaMask" className="wallet-icon" />
                <span className="wallet-name">Metamask</span>
                <svg className="chevron-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 6L15 12L9 18" stroke="#818080" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              
              <button onClick={handleCoinbase} className="wallet-button">
                <div className="wallet-icon coinbase-icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <circle cx="8" cy="8" r="7" fill="none" stroke="white" strokeWidth="2"/>
                  </svg>
                </div>
                <span className="wallet-name">Coinbase Wallet</span>
                <svg className="chevron-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 6L15 12L9 18" stroke="#818080" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              
              <button onClick={handleWalletConnect} className="wallet-button">
                <img src={imgWalletConnect} alt="WalletConnect" className="wallet-icon" />
                <span className="wallet-name">WalletConnect</span>
                <svg className="chevron-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M9 6L15 12L9 18" stroke="#818080" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
            
            <button className="show-more-button">Show more wallet options</button>
            
            <div className="protocol-info">
              <svg className="info-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" stroke="#818080" strokeWidth="1.5"/>
                <path d="M10 14V10M10 6H10.01" stroke="#818080" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span className="info-text">BUILT ON HEDERA GUARDIAN • DECENTRALISED REFI PROTOCOL FOR BITCOIN MINING FARMS</span>
            </div>
          </div>
        </div>
        
        <div className="login-right">
          <div className="branding-content">
            <div className="stars">⭐⭐⭐⭐⭐</div>
            <h2 className="branding-title">
              "Mine Less Earn More<br/>
              The Carbon-Native<br/>
              Protocol"
            </h2>
            <div className="branding-footer">
              <div className="stars-mini">⭐⭐⭐⭐⭐</div>
              <p className="branding-note">BASED ON METHODOLOGY IDEA NOTE M0418 SUBMITTED</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}